import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomFacade, SharedFacade, debounce } from '@piqet-angular/data';
import { CustomModalService, DistanceTypeEnum, commonEnum } from '@piqet-angular/shared';
import { ActionButtonComponent } from '../action-button/action-button.component';
import { ColDef } from 'ag-grid-community';
import { CustomTransportDataGridService } from '@piqet-angular/features';
import { CustomService } from 'libs/data/src/lib/services/custom/custom.service';
import { cloneDeep } from 'lodash';
import { GridIconComponent } from '../grid-icon/grid-icon.component';
import {
  delayedFunctionCall,
  formatNumber,
  noWhitespaceValidator,
  onKeyDown,
} from 'libs/shared/src/lib/service/helper.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { Observable, Subject, Subscription, forkJoin, take } from 'rxjs';
import { MapsAPILoader } from '@agm/core';
import { CookieService } from 'ngx-cookie-service';
@Component({
  selector: 'piqet-angular-new-custom-transport-scenario',
  templateUrl: './new-custom-transport-scenario.component.html',
  styleUrls: ['./new-custom-transport-scenario.component.scss'],
})
export class NewCustomTransportScenarioComponent {
  @Output() saveCustomTransportScenarioEvent = new EventEmitter<{
    payload: any;
    pathName: any;
  }>();
  keyword = 'name';
  isAddManualDistanceData = false;
  pageNumber = 1;
  searchValue: any;
  selectedCities: any;
  customTransportScenarioForm!: FormGroup;
  submitted = false;
  isCustomTruckCheck = false;
  isShowCityRequierd = false;
  allCountriesData: any;
  cityWithPort: any;
  enableMultipleSites = false;
  siteName: any;
  doesExceed: any;
  modalLabel: any;
  hideOriginGrid = true;
  transportationList: any;
  modesOfTransports: any;
  transportIcons: any;
  isAddedInTransport: any;
  addManualDistance: any;
  seaDistance: any;
  isShowPort = false;
  showPortList: any;
  remainingValue: any = 100;
  destinationData: any = {
    transportModeId: 0,
    transportModeName: '',
    cityName: '',
    distance: '',
    cityId: '',
  };
  transportScenarioData: any = {
    transportModeId: 0,
    transportModeName: '',
    cityName: '',
    distance: '',
    cityId: '',
  };
  customTransportScenarioData: any;
  totalProduct: any = 0;
  isManualDistances: any;
  transportName: any;
  truckChecked = false;
  showCustomTruck = false;
  transportModeList: any;
  transportModeName: any;
  transportModeId: any;
  allTransportModes: any;
  distanceTransportationItems: any;
  locationTransportationItems: any;
  columnDefs: ColDef[];
  keywordAuto = '';
  columnDefsSingle: ColDef[];
  multipleTransportColDef: ColDef[];
  setOriginsubmitted = false;
  transportScenarioList: any;
  tempCustomTruck: any;
  isSingleSite: any;
  areMultipleSite: any;
  cityId: any;
  transportationId: any = 2;
  setDestinationsubmitted = false;
  activatedRoute: any;
  transportModeDescription: any;
  selectOrganization: any;
  organizationlist: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  fromEdit: any;
  setOrganizationValue: any;
  selectedDropDownValue: any;
  addInTransport: any;
  customTransportScenarioDetails: any; //For list of cities
  frameworkComponents = {
    actionRenderer: ActionButtonComponent,
    iconsOfTransport: GridIconComponent,
  };
  isLoading = false;
  @Output() saveCustomTruckScenarioEvent = new EventEmitter<any>();
  @ViewChild('auto') auto: any;
  distanceCalc: any;

  subscriptionCustomTransportMnLocationData!: Subscription;
  subscriptionCheckDeleteRowData!: Subscription;
  customTransportManualLocationData: any;
  getOriginAndDestinationEditData: any;
  setDestinationLocationData: any;
  checkIsOrginBtn = true;
  isCheckUpdateOrigin = false;
  isCheckUpdateDestination = false;
  isCheckEditManudalDist = false;
  setManualLocationDisForNextRecord: any;
  lastItem: any;
  setManualLocationDis: any;
  private searchSubject = new Subject<string>();
  private readonly debounceTimeMs = 300; // Set the debounce time (in milliseconds)
  search$!: Observable<string>;
  showEdit = false;
  showCreate = false;
  showView = false;
  checkEntireAccess = false;

  constructor(
    private modal: CustomModalService,
    private formBuilder: FormBuilder,
    public customFacade: CustomFacade,
    public sharedFacade: SharedFacade,
    private customTransportDataGridService: CustomTransportDataGridService,
    private customService: CustomService,
    private sharedService: SharedService,
    private swalService: SwalService,
    private mapsAPILoader: MapsAPILoader,
    private cookieService: CookieService
  ) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.isDisabledDropDown =
      this.modalLabel.toLowerCase() == 'review custom transport chain' ? true : false;
    this.isHideDropDown =
      this.activatedRoute.toLowerCase() == 'admincustomtransport' ? true : false;

    this.fromEdit = this.modal?.modalService?.config?.initialState?.['fromEdit'];
    this.columnDefs = this.customTransportDataGridService.addCustomTransportDataColumn();
    this.columnDefsSingle = this.customTransportDataGridService.addCustomTransportDataColumnSingle(
      this.fromEdit
    );
    this.multipleTransportColDef =
      this.customTransportDataGridService.addMultipleCustomTransportDataColumn(this.fromEdit);

    this.customTransportScenarioData =
      this.modal?.modalService?.config?.initialState?.['newCustomTransportScenarioData'];
    this.customFacade.customTransportListRowData$.subscribe((res: any) => {
      this.customTransportScenarioData =
        (res.hasOwnProperty('length') && res.length) || res
          ? res
          : this.customTransportScenarioData;
      this.initializeData();
    });
  }

  async fingOriginAndDestination(x: any) {
    this.getOriginAndDestinationEditData = x;
    if (this.checkIsOrginBtn) {
      this.isCheckUpdateOrigin = true;
      this.customTransportScenarioForm.patchValue({ origin: this.getOriginAndDestinationEditData });
    } else {
      this.isCheckUpdateDestination = true;
      this.customTransportScenarioForm.patchValue({
        destination: this.getOriginAndDestinationEditData,
      });
    }
  }

  ngOnInit(): void {
    this.showEdit = this.customTransportDataGridService.isAccess(this.activatedRoute, 'edit');
    this.showCreate = this.customTransportDataGridService.isAccess(this.activatedRoute, 'create');
    this.showView = this.customTransportDataGridService.isAccess(this.activatedRoute, 'view');
    this.checkEntireAccess =
      (this.showCreate && !this.fromEdit) ||
      (this.fromEdit && this.showEdit) ||
      (this.fromEdit && !this.showView);
    this.search$ = debounce(this.searchSubject.asObservable(), this.debounceTimeMs);
    this.search$.subscribe(searchValue => {
      this.searchCities(searchValue);
    });
    this.subscriptionCheckDeleteRowData =
      this.customTransportDataGridService.checkDeleteCustomTransportMnLocationData$.subscribe(
        (check: any) => {
          this.customTransportScenarioForm.controls['origin'].reset();
          this.customTransportScenarioForm.controls['destination'].reset();
          this.customTransportScenarioForm.controls['transportMode'].reset();
          this.customTransportScenarioForm.controls['distance'].reset();
          this.isCheckUpdateDestination = false;
          this.isCheckUpdateOrigin = false;
          this.isCheckEditManudalDist = false;
          check[2] && check[0].length > 0 && this.deleteSetDistanceRecord(check[0], check[1]);
        }
      );
    this.subscriptionCustomTransportMnLocationData =
      this.customTransportDataGridService.editCustomTransportManualLocationData$.subscribe(
        async (editData: any) => {
          this.customTransportManualLocationData = editData[0];
          this.truckChecked = editData[0].isCustomTruck;
          this.transportModeId = editData[0].transportModeId;
          this.customFacade.customTransportScenarioList$
            .pipe(take(1))
            .subscribe(async (data: any) => {
              this.checkIsOrginBtn = data.length <= 1 ? true : false;
            });
          if (editData[0].isCheckManualDis) {
            this.isCheckEditManudalDist = true;
            this.truckChecked = editData[0].isCustomTruck;
            this.customTransportScenarioForm.controls['distance'].setValue(editData[0].distance);
            this.checkIsOrginBtn = false;
          }
          if (editData[1]) {
            editData[0] = { ...editData[0] };
            editData[0].name = editData[0].cityName;
            await this.fingOriginAndDestination(editData[0]);
            this.getLastItem();
            const location = editData[0].isCustomTruck
              ? this.tempCustomTruck
              : this.transportModeList;
            const locationId = editData[0].isCustomTruck
              ? editData[0].customTruckId
              : editData[0].transportModeId;
            location.map((x: any) => {
              if (x.id == locationId) {
                this.setDestinationLocationData = x;
                this.customTransportScenarioForm.patchValue({
                  transportMode: this.setDestinationLocationData,
                });
              }
            });
            this.customTransportScenarioForm.patchValue({ distance: editData[0].distance });
          }
        }
      );
    this.getAllCityList();
  }

  initializeData() {
    this.enableMultipleSites = this.customTransportScenarioData?.isCustomSiteTransport
      ? true
      : false;
    this.transportationList = this.customTransportScenarioData?.transportationList;
    this.transportModeList = this.customTransportScenarioData?.transportModeList;
    this.tempCustomTruck = this.customTransportScenarioData?.customTruckList;
    this.organizationlist = this.customTransportScenarioData?.organizationList;

    const scenario =
      this.transportationList || this.transportationList?.length
        ? this.transportationList[0]?.name
        : '';
    this.customTransportScenarioForm = this.formBuilder.nonNullable.group({
      transportScenarioName: [
        this.customTransportScenarioData?.name || '',
        [Validators.required, noWhitespaceValidator],
      ],
      organizationName: [null, Validators.required],
      origin: ['', Validators.required],
      scenario: [scenario || '', Validators.required],
      siteName: ['', [Validators.required, noWhitespaceValidator]],
      product: [(0).toFixed(2), [Validators.required, Validators.max(100), noWhitespaceValidator]],
      transportMode: [null, Validators.required],
      distance: ['', [Validators.required]],
      destination: ['', Validators.required],
    });

    this.organizatioListFunction();
    this.setFormData();
    this.setOrganizationValue = this.selectOrganization;
    this.selectedDropDownValue = this.selectOrganization;
  }

  getAllCityList() {
    this.sharedService.getAllCity().subscribe((res: any) => {
      this.allCountriesData = res.hasOwnProperty('data') ? res.data : res;
    });
  }

  onClose() {
    this.customFacade.clearMultipleTransportScenario();
    this.customFacade.clearTransportScenario();
    this.customFacade.clearTransportScenarioRowData();
    this.customFacade.clearnDistanceError();
    this.modal.close();
  }

  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item?.id == this.customTransportScenarioData?.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }

  setFormData() {
    this.customTransportScenarioForm.patchValue({
      organizationName: this.selectOrganization,
    });
  }

  isChecked(event: any) {
    this.customFacade.clearnDistanceError();
    this.enableMultipleSites = event.target.checked;
    this.setOriginsubmitted = false;
    this.setDestinationsubmitted = false;
    this.showCustomTruck = false;
    this.hideOriginGrid = true;
    this.showCustomTruck = false;
    this.truckChecked = false;
    this.isAddManualDistanceData = false;
    this.isManualDistances = false;
    this.addManualDistance = false;
    this.isCustomTruckCheck = false;
    this.customTransportScenarioForm.controls['transportMode'].setValue(null);
    this.customTransportScenarioForm.controls['distance'].setValue('');
    this.customTransportScenarioForm.controls['origin'].setValue('');
    this.customTransportScenarioForm.controls['destination'].setValue('');
    this.customTransportScenarioForm.controls['siteName'].setValue('');
    this.customTransportScenarioForm.controls['product'].setValue((0).toFixed(2));
    this.customFacade.clearTransportScenario();
  }
  onKeyDownEvent(event: any) {
    if (
      this.keywordAuto == undefined ||
      this.keywordAuto == null ||
      typeof this.keywordAuto == 'object'
    ) {
      this.keywordAuto = '';
    }
    onKeyDown(event, this.keywordAuto);
  }
  onChangeSearch(searchValue: any) {
    if (this.keywordAuto == undefined || this.keywordAuto == null) {
      this.keywordAuto = '';
    }
    this.keywordAuto = this.keywordAuto?.trimStart();
    if (this.keywordAuto.length) {
      this.isLoading = true;
      this.pageNumber = 1;
      this.searchValue = this.keywordAuto;
      this.selectedCities = [];
      this.searchSubject.next(this.keywordAuto);
    }
  }

  onScroll() {
    if (this.selectedCities?.length < 50) return;
    this.pageNumber++;
    this.isLoading = true;
    this.searchCities(this.searchValue);
  }

  onClearSearch(event: any) {
    this.selectedCities = [];
    this.pageNumber = 1;
    this.searchValue = '';
    this.isLoading = false;
    this.selectedCities = [];
    event?.stopPropagation();
    this.auto.close();
    this.customTransportScenarioForm.controls['distance'].setValue(null);
  }

  async searchCities(searchValue: string) {
    const res: any = await this.sharedService.getAllFilterCity(
      this.pageNumber,
      searchValue,
      this.isShowPort
    );
    this.selectedCities = this.pageNumber === 1 ? res.data : [...this.selectedCities, ...res.data];
    this.isLoading = false;
  }

  showPorts(event: any) {
    this.customTransportScenarioForm.controls['origin'].setValue(null);
    this.customTransportScenarioForm.controls['destination'].setValue(null);
    this.isShowPort = event.target.checked;
    this.cityWithPort = this.isShowPort
      ? this.allCountriesData?.filter((item: any) => item.name.includes('(Port)'))
      : [];
  }

  noSpecialKeys(event: any) {
    const allowedKeys = /^[0-9.]$/; // RegEx to allow digits and one decimal point

    if (
      event.key === 'Backspace' ||
      event.key === 'Delete' ||
      event.key === 'ArrowUp' ||
      event.key === 'ArrowRight' ||
      event.key === 'ArrowDown' ||
      event.key === 'ArrowLeft'
    )
      return;

    if (!allowedKeys.test(event.key)) {
      event.preventDefault();
    }

    // logic to allow only one decimal point
    const input = event.target.value;
    const hasDecimalPoint = input.includes('.');

    if (event.key === '.' && hasDecimalPoint) {
      event.preventDefault();
    }
  }

  addManualDistanceData() {
    if (this.enableMultipleSites) {
      this.addManualDistance = true;
    } else {
      this.isAddManualDistanceData = true;
    }
    if (this.columnDefs.length == 4) {
      this.columnDefs = cloneDeep(this.columnDefs);
      this.columnDefs.splice(0, 1);
    }
    this.doesExceed = false;
    if (
      this.customTransportScenarioForm.controls['siteName'].value &&
      this.customTransportScenarioForm.controls['product'].value > 0 &&
      this.customTransportScenarioForm.controls['product'].value <= 100 &&
      !!this.customTransportScenarioForm.controls['distance'].value &&
      this.customTransportScenarioForm.controls['transportMode'].value.name
    ) {
      const transportScenarioData: any = {
        id: 0,
        transportModeId: !this.truckChecked ? this.transportModeId : null,
        transportModeName: this.transportModeName,
        distance: this.customTransportScenarioForm.controls['distance'].value,
        imageName: this.transportModeDescription,
        customTruckId: this.truckChecked ? this.transportModeId : null,
        isCustomTruck: this.truckChecked,
        unit: 'km',
      };
      if (this.isCheckEditManudalDist) {
        transportScenarioData['index'] = this.customTransportManualLocationData.index;
      }
      transportScenarioData['isCheckManualDis'] = true;
      if (this.isCheckEditManudalDist) {
        this.customFacade.updateTransportScenarioActions(transportScenarioData, 'edit');
      } else {
        this.customFacade.addTransportScenarioActions(transportScenarioData, 'add');
      }
      this.customTransportScenarioForm.controls['transportMode'].setValue(null);
      this.customTransportScenarioForm.controls['distance'].setValue('');
      this.hideOriginGrid = false;
      this.addManualDistance = false;
      this.isCheckEditManudalDist = false;
    }
  }

  triggerScenarioChangeEventMannually() {
    const dropdown = document.getElementById('transportationList') as HTMLSelectElement;
    this.showCustomTruck = false;
    this.setDestinationsubmitted = false;
    this.isAddManualDistanceData = false;
    this.setOriginsubmitted = false;
    this.addManualDistance = false;
    this.isManualDistances = dropdown.innerText == 'Manual Distances' ? true : false;
    this.transportationId = this.isManualDistances == true ? 3 : 2;
    this.customFacade.clearTransportScenario();
  }

  changeScenario(event: any) {
    // When we change dropddown value of Manual transportation list
    this.showCustomTruck = false;
    this.setDestinationsubmitted = false;
    this.isAddManualDistanceData = false;
    // this.isManualDistances = false;
    this.setOriginsubmitted = false;
    this.addManualDistance = false;
    this.isManualDistances = event.name == 'Manual Distances' ? true : false;
    this.checkIsOrginBtn = event.name == 'Manual Distances' ? false : true;
    this.transportationId = event.id;
    this.isCustomTruckCheck = false;
    this.truckChecked = false;
    this.setTransportModeDropDown(this.isCustomTruckCheck);
    this.customTransportScenarioForm.controls['transportMode'].setValue(null);
    this.customTransportScenarioForm.controls['distance'].setValue('');
    this.customTransportScenarioForm.controls['origin'].setValue('');
    this.customTransportScenarioForm.controls['destination'].setValue('');
    this.customFacade.clearTransportScenario();
  }

  async changeTransportMode(event: any) {
    if (event?.id) {
      this.transportModeId = event.id
        ? event.id
        : this.customTransportScenarioForm.controls['transportMode'].value;
      this.transportModeName = event.name
        ? event.name
        : this.transportModeList.find(
            (x: any) => x.id == this.customTransportScenarioForm.controls['transportMode'].value
          ).name;
      this.transportModeDescription = event.description
        ? event.description
        : this.transportModeList.find(
            (x: any) => x.id == this.customTransportScenarioForm.controls['transportMode'].value
          ).description;
      this.calculateDistanceCon('destination', this.transportModeName);
    } else {
      this.customTransportScenarioForm.controls['distance'].setValue(null);
    }
  }

  async selectEvent(event: any) {
    this.cityId = event.idStr;
    this.keywordAuto = '';
    this.selectedCities = [];
    this.calculateDistanceCon('transportMode');
  }

  alertConfirmation(data: any) {
    this.swalService
      .confirm(
        'Are you sure?',
        'Are you sure you want to change the organization? if you are change the organization than energy process data will be lost.',
        'organization'
      )
      .then(confirmed => {
        if (confirmed) {
          this.setOrganizationValue = data;
          this.selectedDropDownValue = data;
        } else {
          this.setOrganizationValue = this.selectedDropDownValue;
        }
      });
  }

  selectValue(event: any) {
    if (event.name) {
      this.alertConfirmation(event);
    }
  }
  getLastItem() {
    this.customFacade.customTransportScenarioList$.pipe(take(1)).subscribe((data: any) => {
      this.lastItem = this.isCheckUpdateDestination
        ? data[
            data.findIndex(
              (item: any) => item.index === this.customTransportManualLocationData.index
            ) - 1
          ]
        : data[data?.length - 1];
    });
  }

  async getCalculateDis() {
    await this.mapsAPILoader.load();
    const service = new google.maps.DistanceMatrixService();
    const request: any = {
      origins: [this.lastItem.cityName],
      destinations: [this.customTransportScenarioForm.controls['destination'].value.name],
      travelMode: 'DRIVING',
    };
    return new Promise((resolve, reject) => {
      service.getDistanceMatrix(request, (response: any, status: any) => {
        if (status === 'OK') {
          // const distance = response.rows[response.rows.length - 1].elements[response.rows[response.rows.length - 1].elements.length - 1] .distance.text;
          // change that code
          const distance = response.rows[0].elements[0].distance?.text
            ? response.rows[0].elements[0].distance?.text
            : '0 km';
          if (!this.isCheckUpdateDestination) {
            this.customTransportScenarioForm.controls['distance'].setValue(distance);
          }
          this.setManualLocationDis = distance;
          resolve(distance);
        } else {
          reject(new Error(`Distance calculation failed with status: ${status}`));
        }
      });
    });
  }

  async calculateDistanceCon(controlName: any, type?: any) {
    this.getLastItem();
    if (!this.isManualDistances && this.customTransportScenarioForm.controls[controlName].value) {
      this.distanceCalc =
        type == commonEnum.shipName
          ? await this.seaDistanceMatrix(this.lastItem)
          : await this.calculateDistance(this.lastItem);
    }
  }

  async calculateDistance(lastItem: any) {
    const payload = {
      origin: lastItem.cityName,
      destination: this.customTransportScenarioForm.controls['destination'].value.name,
      destinationId: Number(this.customTransportScenarioForm.controls['destination'].value.idStr),
      iscustomtruck: this.truckChecked,
      transportmodeId: this.transportModeId,
      customTransoportScenarioDetails: [
        {
          id: 0,
          cityId: lastItem.cityId,
          cityName: lastItem.cityName,
          transportModeName: this.transportModeName,
          customTransportScenarioId: 0,
          imageName: lastItem.description,
        },
      ],
    };
    const response = await this.customService.getSeaDistanceForTransportAsync(payload);
    if (
      (response.data.distance >= 0 && response.data.isShip) ||
      response?.message.includes('must be a valid Port')
    ) {
      this.customFacade.setCustomTransportError('');
      this.customFacade.setMultipleCustomTransportError('');
      await this.seaDistanceMatrix(this.lastItem);
      return response;
    } else {
      if (
        this.transportModeId == commonEnum.AIR_INTERNATIONAL ||
        this.transportModeId == commonEnum.AIR_DOMESTIC
      ) {
        await this.seaDistanceMatrix(this.lastItem);
      } else {
        await this.getCalculateDis();
      }
    }
  }

  isTruckChecked(event: any) {
    // When custom trucks is checked
    this.truckChecked = event.target.checked ? true : false;
    this.setTransportModeDropDown(this.truckChecked);
  }

  setTransportModeDropDown(flag: boolean) {
    this.customTransportScenarioForm.controls['transportMode'].setValue(null);
  }

  refreshTruckList() {
    this.customService.getCustomTruckListOfCurrentOrganization().subscribe((response: any) => {
      // this.transportModeList = response.data;
      this.tempCustomTruck = response.data;
    });
  }

  setOrigin() {
    this.setOriginsubmitted = true;
    if (this.customTransportScenarioForm.controls['product'].value > this.remainingValue) {
      this.doesExceed = true;
      return;
    } else {
      this.doesExceed = false;
    }
    if (
      (this.enableMultipleSites &&
        this.customTransportScenarioForm.controls['siteName'].value &&
        this.customTransportScenarioForm.controls['product'].value > 0 &&
        this.customTransportScenarioForm.controls['product'].value <= 100 &&
        this.customTransportScenarioForm.controls['origin'].value.idStr) ||
      (!this.enableMultipleSites && this.customTransportScenarioForm.controls['origin'].value.idStr)
    ) {
      this.showCustomTruck = true;
      this.transportScenarioData = {
        transportModeId: !this.truckChecked ? this.transportModeId : null,
        //transportModeId: this.transportModeId,
        id: 0,
        cityName: this.customTransportScenarioForm.controls['origin'].value.name,
        distance: '',
        cityId: this.cityId,
        customTruckId: this.truckChecked ? this.transportModeId : null,
        isCustomTruck: this.truckChecked,
      };
      this.transportScenarioData['isCheckManualDis'] = false;
      if (this.isCheckUpdateOrigin) {
        this.customFacade.updateTransportScenarioActions(this.transportScenarioData, 'edit');
      } else {
        this.customFacade.addTransportScenarioActions(this.transportScenarioData, 'add');
      }

      this.setOriginsubmitted = false;
      this.checkIsOrginBtn = false;
      this.isCheckUpdateOrigin = false;
      this.hideOriginGrid = false;
      this.customTransportScenarioForm.controls['origin'].setValue(null);
    }
  }

  async getCalculateDisForNextRecord(lastItem: any, nextItem: any) {
    await this.mapsAPILoader.load();
    const service = new google.maps.DistanceMatrixService();
    const request: any = {
      origins: [lastItem],
      destinations: [nextItem.cityName],
      travelMode: 'DRIVING',
    };
    return new Promise((resolve, reject) => {
      service.getDistanceMatrix(request, (response: any, status: any) => {
        if (status === 'OK') {
          const distance = response.rows[0].elements[0].distance?.text
            ? response.rows[0].elements[0].distance?.text
            : '0 km';
          this.setManualLocationDisForNextRecord = distance;
          resolve(distance);
        } else {
          reject(new Error(`Distance calculation failed with status: ${status}`));
        }
      });
    });
  }

  changeNextRecordDistance() {
    this.customFacade.customTransportScenarioList$.pipe(take(1)).subscribe(async (data: any) => {
      const startIndex = data.findIndex(
        (item: any) => item.index === this.customTransportManualLocationData.index
      ); // Index to start checking after
      if (this.isCheckUpdateDestination && startIndex < data.length - 1) {
        let destinationNextRecord =
          data[
            data.findIndex(
              (item: any) => item.index === this.customTransportManualLocationData.index
            ) + 1
          ];
        const lastItemNextRecord = this.customTransportScenarioForm.value.destination;
        try {
          await this.getCalculateDisForNextRecord(lastItemNextRecord.name, destinationNextRecord);
          Object.freeze(destinationNextRecord);
          const objCopy = { ...destinationNextRecord };
          objCopy.distance = this.setManualLocationDisForNextRecord;
          destinationNextRecord = objCopy;
          this.customFacade.updateTransportScenarioActions(destinationNextRecord, 'edit');
        } catch (error) {
          // Handle error, e.g., log it or show a user-friendly message.
          console.error('Error:', error);
        }
      }
    });
  }

  deleteSetDistanceRecord(allRecorsds: any, deleteRecord: any) {
    this.customFacade.customTransportScenarioList$
      .pipe(take(1))
      .subscribe(async (allManualLocationData: any) => {
        const indexToDelete = allRecorsds.findIndex(
          (record: any) => record.index === deleteRecord.index
        );
        if (indexToDelete !== -1) {
          // Delete the record
          // Create a new array excluding the deleted record
          const newArray = allRecorsds.filter((record: any, index: any) => index !== indexToDelete);
          const aboveRecord = newArray[indexToDelete - 1];
          let belowRecord = newArray[indexToDelete];
          // newArray now contains the array with the specified record deleted
          if (belowRecord) {
            await this.getCalculateDisForNextRecord(aboveRecord.cityName, belowRecord);
            Object.freeze(belowRecord);
            const objCopy = { ...belowRecord };
            objCopy.distance = this.setManualLocationDisForNextRecord;
            objCopy.index = allManualLocationData[indexToDelete].index;
            belowRecord = objCopy;
            this.customFacade.updateTransportScenarioActions(belowRecord, 'edit');
          }
        }
      });
  }

  seaDistanceMatrix(lastItem: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const fromCity = lastItem.cityName;
      const toCity = this.customTransportScenarioForm.controls['destination'].value?.name;
      const bothCity: string[] = [fromCity, toCity];
      const geocoder = new google.maps.Geocoder();

      // Use map to create an array of observables for geocoding requests
      const geocodeRequests = bothCity.map((address: string) => {
        return new Observable(observer => {
          geocoder.geocode({ address: address }, (results, status) => {
            if (status === 'OK') {
              const location = results![0].geometry.location;
              observer.next({ latitude: location.lat(), longitude: location.lng() });
              observer.complete();
            } else {
              observer.error(`Geocode was not successful for ${address} due to: ` + status);
            }
          });
        });
      });

      // Wait for all geocoding requests to complete
      forkJoin(geocodeRequests).subscribe(
        async (results: any[]) => {
          const [fromLocation, toLocation] = results;
          const latFrom = fromLocation.latitude;
          const lngFrom = fromLocation.longitude;
          const latTo = toLocation.latitude;
          const lngTo = toLocation.longitude;

          // Now you can make the API call
          const distanceType = this.sharedService.getDistanceTypeByTransportMode(
            this.transportModeId
          );
          const res = await this.sharedService.getDistanceAndTime(
            latFrom,
            lngFrom,
            latTo,
            lngTo,
            lastItem?.originId || lastItem?.cityId,
            this.customTransportScenarioForm.controls['destination'].value?.idStr,
            distanceType
          );
          if (
            this.transportModeId == commonEnum.AIR_INTERNATIONAL ||
            this.transportModeId == commonEnum.AIR_DOMESTIC
          ) {
            this.customTransportScenarioForm.controls['distance'].setValue(
              formatNumber(res.data) + ' ' + 'km'
            );
            this.setManualLocationDis = formatNumber(res.data) + ' ' + 'km';
          } else if (this.transportModeId == commonEnum.SHIP_INTERNATIONAL) {
            this.seaDistance = formatNumber(res.data) + ' ' + 'km';
            this.customTransportScenarioForm.controls['distance'].setValue(
              formatNumber(res.data) + ' ' + 'km'
            );
          }
          resolve(); // Resolve the promise once everything is done
        },
        error => {
          console.error(error);
          reject(error); // Reject the promise in case of an error
        }
      );
    });
  }

  async setDestination() {
    const data: any = this.distanceCalc ? this.distanceCalc : [];
    this.setDestinationsubmitted = true;
    if (
      this.customTransportScenarioForm.controls['product'].value > this.remainingValue &&
      !this.enableMultipleSites
    ) {
      this.doesExceed = true;
      return;
    } else {
      this.doesExceed = false;
    }
    if (data?.messageType == 1 && !this.truckChecked) {
      this.customTransportScenarioForm.controls['transportMode'].reset();
      this.enableMultipleSites
        ? this.customFacade.setMultipleCustomTransportError(data.message)
        : this.customFacade.setCustomTransportError(data.message);

      this.setDestinationsubmitted = false;
    } else if (
      !!this.customTransportScenarioForm.controls['distance'].value &&
      (this.customTransportScenarioForm.controls['product'].value > 0 ||
        !this.enableMultipleSites) &&
      this.customTransportScenarioForm.controls['transportMode'].value != null &&
      this.customTransportScenarioForm.controls['destination'].value &&
      (!!this.customTransportScenarioForm.controls['destination'].value?.idStr ||
        this.customTransportScenarioForm.controls['destination'].value?.cityId)
    ) {
      !!this.customTransportManualLocationData?.cityId &&
        (this.customTransportScenarioForm.value.destination?.idStr ||
          this.customTransportScenarioForm.controls['destination'].value?.cityId) !=
          this.customTransportManualLocationData?.cityId &&
        this.changeNextRecordDistance();
      this.isShowCityRequierd = false;
      this.destinationData = {
        // transportModeId: !this.truckChecked ? this.transportModeId : null,
        transportModeId: !this.truckChecked
          ? this.customTransportScenarioForm.controls['transportMode'].value.id
          : null,
        //transportModeId: this.transportModeId,
        transportModeName: this.customTransportScenarioForm.controls['transportMode'].value.name,
        cityName: this.customTransportScenarioForm.controls['destination'].value.name,
        distance: this.customTransportScenarioForm.controls['distance'].value,
        cityId:
          this.customTransportScenarioForm.controls['destination'].value.idStr ||
          this.customTransportScenarioForm.controls['destination'].value?.cityId,
        imageName: this.transportModeDescription,
        siteName: this.customTransportScenarioForm.controls['siteName'].value,
        productPercentage: Number(this.customTransportScenarioForm.controls['product'].value),
        // customTruckId: this.truckChecked ? this.transportModeId : null,
        customTruckId: this.truckChecked
          ? this.customTransportScenarioForm.controls['transportMode'].value.id
          : null,
        isCustomTruck: this.truckChecked,
      };
      this.destinationData['isCheckManualDis'] = false;
      this.destinationData['enableMultipleSites'] = this.enableMultipleSites;
      if (this.isCheckUpdateDestination) {
        this.destinationData['index'] = this.customTransportManualLocationData.index;
      }
      if (this.isCheckUpdateDestination) {
        this.customFacade.updateTransportScenarioActions(this.destinationData, 'edit');
      } else {
        this.customFacade.addTransportScenarioActions(this.destinationData, 'add');
      }
      this.setDestinationsubmitted = false;
      this.isCheckUpdateDestination = false;
      this.customTransportScenarioForm.controls['transportMode'].setValue(null);
      this.customTransportScenarioForm.controls['distance'].setValue('');
      this.customTransportScenarioForm.controls['origin'].setValue('');
      this.customTransportScenarioForm.controls['destination'].setValue('');
    }
  }

  addInTransportScenario(transportScenarioList: any, multipleTransportScenarioList: any) {
    this.addInTransport = true;
    this.transportName =
      transportScenarioList.findIndex((x: any) => x.hasOwnProperty('cityName')) >= 0
        ? transportScenarioList
            .map((element: any, index: any, array: any) => {
              return array[index]?.cityName;
            })
            .join(', ')
        : '';

    this.transportIcons = transportScenarioList.map((ele: any, index: any, arr: any) => {
      return arr[index]?.imageName;
    });

    this.modesOfTransports = transportScenarioList
      .map((element: any, index: any, array: any) => {
        return array[index].transportModeName;
      })
      .join(', ');

    this.allTransportModes = transportScenarioList.map((element: any, index: any, array: any) => {
      const multipleTransports = {
        transportModeId: array[index].transportModeId,
        transportModeName: array[index].transportModeName,
      };
      return multipleTransports;
    });

    if (!transportScenarioList[0].isCheckManualDis) {
      transportScenarioList = transportScenarioList.map((item: any) => {
        if (typeof item.distance === 'string' && item.distance != 0) {
          const type = item.distance?.substring(item.distance.indexOf(' ') + 1);
          Object.freeze(item);
          const objCopy = { ...item };
          const distanceWithoutCommas = item.distance.replace(/,/g, '');
          objCopy.distance = parseFloat(distanceWithoutCommas);
          objCopy.unit = type;
          item = objCopy;
        } else {
          Object.freeze(item);
          const objCopy = { ...item };
          objCopy.unit = 'km';
          item = objCopy;
        }
        return item;
      });
    }

    this.totalProduct = 0;
    multipleTransportScenarioList.map((item: any) => {
      this.totalProduct = this.totalProduct + Number(item.productPercentage);
    });
    if (
      Number(this.customTransportScenarioForm.controls['product'].value) + this.totalProduct >
      100
    ) {
      this.doesExceed = true;
      return;
    }

    if (
      this.customTransportScenarioForm.controls['siteName'].value &&
      this.customTransportScenarioForm.controls['product'].value > 0 &&
      this.customTransportScenarioForm.controls['product'].value <= 100
    ) {
      this.totalProduct =
        Number(this.customTransportScenarioForm.controls['product'].value) + this.totalProduct;
      const payload: any = {
        siteName: this.customTransportScenarioForm.controls['siteName'].value,
        productPercentage: Number(this.customTransportScenarioForm.controls['product'].value),
        cityName: this.transportName,
        transportModeName: this.transportModeName,
        transportIcons: this.transportIcons,
        description: this.transportModeDescription,
        distance: this.customTransportScenarioForm.controls['distance'].value,
        siteId: 0,
        transportationId: this.transportationId,
        transportModeId: !this.truckChecked ? this.transportModeId : null,
        //transportModeId: this.transportModeId,
        customTruckId: this.truckChecked ? this.transportModeId : null,
        isCustomTruck: this.truckChecked,
      };
      payload['isCheckManualDis'] = true;
      this.transportationId == 2
        ? (payload['locationTransportationItems'] = transportScenarioList)
        : (payload['distanceTransportationItems'] = transportScenarioList);

      if (payload.productPercentage > this.remainingValue) {
        this.doesExceed = true;
        return;
      } else {
        this.doesExceed = false;
        this.customFacade.addMultipleTransportScenarioActions(payload, 'add');
        this.customTransportScenarioForm.controls['transportMode'].setValue(null);
        this.customTransportScenarioForm.controls['distance'].setValue('');
        this.customTransportScenarioForm.controls['origin'].setValue('');
        this.customTransportScenarioForm.controls['destination'].setValue('');
        this.customTransportScenarioForm.controls['siteName'].setValue('');
        this.customTransportScenarioForm.controls['product'].setValue((0).toFixed(2));
      }

      this.customFacade.remainingValue$.subscribe((data: any) => {
        this.remainingValue = data;
        this.customTransportScenarioForm.controls['product'].setValue(data);
      });
      this.hideOriginGrid = true;
      this.showCustomTruck = false;
      this.customFacade.clearTransportScenario();
      this.truckChecked = false;
      this.setDestinationsubmitted = false;
      this.isAddManualDistanceData = false;
      this.isManualDistances = false;
      this.setOriginsubmitted = false;
      this.addManualDistance = false;
      this.isCustomTruckCheck = false;
      this.setTransportModeDropDown(this.isCustomTruckCheck);
      this.triggerScenarioChangeEventMannually();
    }
  }

  onSave(transportScenarioList: any, multipleTransportScenarioList: any) {
    this.submitted = true;
    let singleTransportScenario =
      transportScenarioList || this.customTransportScenarioData.customTransportScenarioDetails;
    const multipleTransportScenario =
      multipleTransportScenarioList || this.customTransportScenarioData.customSiteTransports;

    singleTransportScenario = singleTransportScenario.map((item: any) => {
      if (typeof item.distance === 'string' && item.distance != 0) {
        const type = item.distance?.substring(item.distance.indexOf(' ') + 1);
        Object.freeze(item);
        const objCopy = { ...item };
        const distanceWithoutCommas = item.distance.replace(/,/g, '');
        objCopy.distance = parseFloat(distanceWithoutCommas);
        objCopy.unit = type;
        objCopy.id = 0;
        item = objCopy;
      } else {
        Object.freeze(item);
        const objCopy = { ...item };
        objCopy.unit = 'km';
        objCopy.id = 0;
        item = objCopy;
      }
      return item;
    });

    if (!this.customTransportScenarioForm.controls['transportScenarioName'].valid) {
      return;
    } else {
      this.submitted = false;
      let addTransportScenarioPayload: any = {
        id: this.customTransportScenarioData?.id || 0,
        transportModeId: this.transportModeId,
        customTransportScenarioId: 0,
        isCustomSiteTransport: this.enableMultipleSites,
        name: this.customTransportScenarioForm.controls['transportScenarioName'].value.trimStart(),
        userId: Number(this.cookieService.get('userId')),
        organizationId:
          this.customTransportScenarioForm.controls['organizationName'].value?.id ||
          this.customTransportScenarioData?.organizationId ||
          Number(this.cookieService.get('organizationId')),
        isCustomTruck: this.truckChecked,
        productPercentage: this.customTransportScenarioForm.controls['product'].value
          ? Number(this.customTransportScenarioForm.controls['product'].value)
          : this.customTransportScenarioData.productPercentageSum,
        customSiteTransports: multipleTransportScenario,
      };

      this.enableMultipleSites
        ? (addTransportScenarioPayload = addTransportScenarioPayload)
        : (addTransportScenarioPayload['customTransportScenarioDetails'] = singleTransportScenario);

      this.saveCustomTransportScenarioEvent.emit({
        payload: addTransportScenarioPayload,
        pathName: this.activatedRoute,
      });
    }
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  ngOnDestroy(): void {
    this.customFacade.clearTransportScenarioRowData();
    this.customFacade.setCustomTransportError('');
    this.customFacade.clearnDistanceError();
    this.customFacade.setMultipleCustomTransportError('');
  }
}
